import { makeStyles } from 'tss-react/mui'
import { alpha } from '@mui/material'
import { colors } from '@/theme/colors.theme'

export const useStyles = makeStyles({ name: 'PickersDay' })(() => {
  const border = `2px solid ${colors.blue}`
  const styles = {
    borderTop: border,
    borderBottom: border,
    background: `${alpha(colors.blue, 0.3)}!important`,
    color: colors.white,
  }
  return {
    highlight: {
      ...styles,
      margin: 0,
    },
    firstHighlight: {
      ...styles,
      borderLeft: border,
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%',
    },
    endHighlight: {
      ...styles,
      borderRight: border,
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%',
    },
  }
})
